import { Action } from 'redux';

import { IDataAlertInfo } from '../../../ts/models/IDataAlertInfo';
import { DataAlertAddMe, DataAlertEdit, DataAlertRemoveMe, DataAlertResume } from '../AppActionTypes';

export interface DataAlertMenuAction extends Action {
  items: IDataAlertInfo[];
}

export function dataAlertAddMe(items: IDataAlertInfo[]): DataAlertMenuAction {
  return {
    type: DataAlertAddMe,
    items
  };
}

export function dataAlertRemoveMe(items: IDataAlertInfo[]): DataAlertMenuAction {
  return {
    type: DataAlertRemoveMe,
    items
  };
}

export function dataAlertResume(items: IDataAlertInfo[]): DataAlertMenuAction {
  return {
    type: DataAlertResume,
    items
  };
}

export function dataAlertEdit(items: IDataAlertInfo[]): DataAlertMenuAction {
  return {
    type: DataAlertEdit,
    items
  };
}
